/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ObjectResult } from '../../models/object-result';
import { UpsertUserCommand } from '../../models/upsert-user-command';

export interface ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Json$Params {
      body?: UpsertUserCommand
}

export function apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Json(http: HttpClient, rootUrl: string, params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
  const rb = new RequestBuilder(rootUrl, apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json;odata.metadata=none;odata.streaming=true');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ObjectResult>;
    })
  );
}

apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Json.PATH = '/api/upsert-user';
